/* Kerdan Premium · interacciones. Sin librerías, sin módulos. */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  w.KERDAN_READY = true;
  function safe(fn, name) { try { fn(); } catch (e) { if (w.console) console.warn('[kerdan] ' + name, e); } }
  function onReady(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  var scrollFns = [], ticking = false;
  function onScroll(fn) { scrollFns.push(fn); }
  function runScroll() { ticking = false; for (var i = 0; i < scrollFns.length; i++) safe(scrollFns[i], 'scroll'); }
  w.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(runScroll); } }, { passive: true });
  w.addEventListener('resize', function () { w.requestAnimationFrame(runScroll); });

  function initReveal() {
    var els = [].slice.call(d.querySelectorAll('.k-reveal:not(.is-in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in w)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { fired = true; en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () {
      [].forEach.call(d.querySelectorAll('.k-reveal:not(.is-in)'), function (e) {
        if (!fired || e.getBoundingClientRect().top < w.innerHeight) e.classList.add('is-in');
      });
    }, 6000);
  }

  function initHeader() {
    var h = d.querySelector('[data-k-header]');
    if (!h) return;
    onScroll(function () { h.classList.toggle('is-scrolled', w.scrollY > 10); });
    var b = h.querySelector('.k-burger');
    if (b) b.addEventListener('click', function () {
      var open = h.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    });
  }

  function initTilt() {
    if (!w.matchMedia || !w.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    [].forEach.call(d.querySelectorAll('[data-tilt]'), function (box) {
      var t = box.querySelector('.k-tilt');
      if (!t) return;
      box.addEventListener('pointermove', function (e) {
        var r = box.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        t.style.transform = 'rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg) translateZ(0)';
      });
      box.addEventListener('pointerleave', function () { t.style.transform = ''; });
    });
  }

  function initParallax() {
    var els = [].slice.call(d.querySelectorAll('[data-parallax]'));
    if (!els.length) return;
    onScroll(function () {
      var vh = w.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var k = parseFloat(el.getAttribute('data-parallax')) || 0.1;
        var off = (r.top + r.height / 2 - vh / 2) * k;
        el.style.translate = '0 ' + off.toFixed(1) + 'px';
      });
    });
  }

  function initWords() {
    [].forEach.call(d.querySelectorAll('[data-words]'), function (el) {
      if (el.querySelector('.w')) return;
      var words = el.textContent.trim().split(/\s+/);
      el.innerHTML = '';
      words.forEach(function (wd, i) {
        var s = d.createElement('span'); s.className = 'w'; s.textContent = wd;
        el.appendChild(s); if (i < words.length - 1) el.appendChild(d.createTextNode(' '));
      });
      var spans = el.querySelectorAll('.w');
      onScroll(function () {
        var r = el.getBoundingClientRect(), vh = w.innerHeight;
        var p = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.3), 0, 1);
        var n = Math.round(p * spans.length);
        for (var i = 0; i < spans.length; i++) spans[i].classList.toggle('on', i < n);
      });
    });
  }

  function initCounters() {
    var els = [].slice.call(d.querySelectorAll('[data-count]'));
    if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-count')); if (isNaN(to)) return;
      var t0 = null, dur = 1400;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * e);
        if (p < 1) w.requestAnimationFrame(step); else el.textContent = el.getAttribute('data-final') || to;
      }
      w.requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in w)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { run(x.target); io.unobserve(x.target); } });
    }, { threshold: 0.3 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initSteps() {
    [].forEach.call(d.querySelectorAll('[data-steps]'), function (list) {
      var line = list.querySelector('.k-steps__line'), steps = [].slice.call(list.querySelectorAll('.k-step'));
      onScroll(function () {
        var r = list.getBoundingClientRect(), vh = w.innerHeight;
        var p = clamp((vh * 0.75 - r.top) / (r.height + vh * 0.1), 0, 1);
        if (line) line.style.setProperty('--p', p.toFixed(3));
        steps.forEach(function (s, i) { s.classList.toggle('is-on', p >= (steps.length > 1 ? i / (steps.length - 1) : 0) - 0.001); });
      });
    });
  }

  function initGallery() {
    [].forEach.call(d.querySelectorAll('[data-gallery]'), function (g) {
      var main = g.querySelector('[data-main]');
      [].forEach.call(g.querySelectorAll('[data-thumb]'), function (btn) {
        btn.addEventListener('click', function () {
          if (!main) return;
          main.style.opacity = '0.2';
          var src = btn.getAttribute('data-src'), srcset = btn.getAttribute('data-srcset');
          setTimeout(function () { if (srcset) main.setAttribute('srcset', srcset); main.src = src; main.style.opacity = '1'; }, 160);
          [].forEach.call(g.querySelectorAll('[data-thumb]'), function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
        });
      });
    });
  }

  function initStickyBar() {
    var bar = d.querySelector('[data-stickybar]'), anchor = d.querySelector('[data-buy-anchor]');
    if (!bar || !anchor) return;
    onScroll(function () {
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-on', r.bottom < 0);
    });
  }

  onReady(function () {
    safe(initReveal, 'reveal'); safe(initHeader, 'header'); safe(initTilt, 'tilt');
    safe(initParallax, 'parallax'); safe(initWords, 'words'); safe(initCounters, 'counters');
    safe(initSteps, 'steps'); safe(initGallery, 'gallery'); safe(initStickyBar, 'stickybar');
    runScroll();
  });
})();
